export default __webpack_public_path__ + "static/media/flexip.22c304d4.svg";